(function () {
    'use strict';

    angular
        .module('tikonApp')
        .directive('onFileChange', onFileChange);

    function onFileChange() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.onFileChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function () {
                    element.off();
                });

            }
        };
    }
})();
